/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendChartDto } from '../../models/backend-chart-dto';

export interface MonitoringFinanceDataForChartsRetrieve$Params {
  /**
   * Период финансовых данных ("month" или "year"). По умолчанию "month".
   */
  period?: 'month' | 'year';
  scenario_id: number;
}

export function monitoringFinanceDataForChartsRetrieve(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringFinanceDataForChartsRetrieve$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendChartDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringFinanceDataForChartsRetrieve.PATH, 'get');
  if (params) {
    rb.query('period', params.period, {});
    rb.path('scenario_id', params.scenario_id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendChartDto>;
    }),
  );
}

monitoringFinanceDataForChartsRetrieve.PATH = '/api/monitoring/finance_data_for_charts/{scenario_id}/';
